import { ColumnConfig, ColumnDataType } from '@aurora';

export const conversationColumnsConfig: ColumnConfig[] = [
    {
        type: ColumnDataType.STRING,
        field: 'title',
        sort: 'title',
        translation: 'chat.Title',
        isUnaccent: true,
    },
];
